declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';



import { ActorService } from '../../../../services/actor.service';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { HcareService } from '../../../../services/hcare.service';
import {
  JobApplyDetailsInfoByJobPostWithNurseController, JobApplyDetailsInfoByJobPostWithNurseRequest, 
  EmpNonAvailabilityRequest,
  EmpNonAvailabilityCheckRequest,
  EmpNonAvailabilityController
} from '../../../../models/hcare/hcare.model';




import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CodeTypeValueComponent } from '../../../../custumcomponents/codetypes/codetypevalue.component';

@Component({
  selector: 'scheduleassistant',
  templateUrl: './scheduleassistant.modal.html',
  styleUrls: ['./scheduleassistant.modal.scss']
})

export class NgbScheduleAssistantModal implements OnInit {
  

  public isRequesting: boolean = false;
  public IsAvailable: boolean = false;
  public IsNotAvailable: boolean = false;
  public EmpNonAvialabilityReason: string = "";
  public NARemarks: string = "";
  public ApiResData: ApiResponseModel;
  Selectedjob: JobApplyDetailsInfoByJobPostWithNurseController;
  CurrentJobApplyDetailsInfoByJobPostWithNurseRequest: JobApplyDetailsInfoByJobPostWithNurseRequest;
  public ActorCode: number;
  public JobPostCode: number;
  EmpNonAvailabilityRequest: EmpNonAvailabilityRequest;

  SaveNonAvailability() {

    // alert(this.EmpNonAvialabilityReason + " : " + this.NARemarks);


    this.EmpNonAvailabilityRequest.NurseActorCode = this.ActorCode;
    //this.EmpNonAvailabilityRequest.RequestedDate = new Date();
    this.SelectedDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth(), day: this.TodayDate.getDate() };
    this.EmpNonAvailabilityRequest.RequestedDate  = new Date(this.parserFormatter.format(this.SelectedDate));
    this.EmpNonAvailabilityRequest.HospitalActorCode = 0;
    this.EmpNonAvailabilityRequest.Reason = this.EmpNonAvialabilityReason;
    this.EmpNonAvailabilityRequest.Remarks = this.NARemarks;

    
    //alert(this.EmpNonAvailabilityRequest.ConditionalOperator);
    
    this.EmpNonAvailabilityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.StartRefreshing();


    this.hcareservice.SaveEmpNonAvailability(this.EmpNonAvailabilityRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            alertFunctions.AlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();

    
          }
          else {
            alertFunctions.AlertParam("--- Invalid Operation...!" + this.ApiResData.ErrorData);
       

            this.stopRefreshing();
            this.activeModal.close();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
      }
      );


  }
  SelectedDate: NgbDateStruct;
  TodayDate = new Date();
  EmpNonAvailabilityCheckRequest: EmpNonAvailabilityCheckRequest;
  EmpNonAvailabilityController: EmpNonAvailabilityController;
  GetEmpNonAvailabilityController() {
    this.EmpNonAvailabilityCheckRequest = new EmpNonAvailabilityCheckRequest();
    this.EmpNonAvailabilityCheckRequest.ConditionalOperator = 1; 
    this.EmpNonAvailabilityCheckRequest.HospitalActorCode = 0;
    this.EmpNonAvailabilityCheckRequest.NurseActorCode = this.ActorCode;
    this.SelectedDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() , day: this.TodayDate.getDate() };
    this.EmpNonAvailabilityCheckRequest.RequestedDate = new Date(this.parserFormatter.format(this.SelectedDate));
    this.EmpNonAvailabilityCheckRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.StartRefreshing();
    this.hcareservice.GetEmpNonAvailabilityController(this.EmpNonAvailabilityCheckRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.EmpNonAvailabilityController = this.ApiResData.Result[0];
          this.IsAvailable = (this.EmpNonAvailabilityController.Availability == "Available") ?
            true : false;
          this.NARemarks = this.EmpNonAvailabilityController.Remarks;
          this.EmpNonAvialabilityReason = this.EmpNonAvailabilityController.Reason;
          //alert(this.EmpNonAvialabilityReason);
          if (this.IsAvailable) {
            this.EmpNonAvailabilityRequest.ConditionalOperator = 1;

            this.GetCurrentDashBoardProfileSummaryController();

          }
          else
            this.EmpNonAvailabilityRequest.ConditionalOperator = 2;
          this.EmpNonAvailabilityRequest.EmpNonAvailabilityCode = this.EmpNonAvailabilityController.EmpNonAvailabilityCode;
          // console.log('this.CurrentActorProfileSummaryInfoController ' + this.CurrentActorProfileSummaryInfoController.DisplayName);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }


  constructor(public activeModal: NgbActiveModal,
    private loaderService: SpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private hcareservice: HcareService, 
    private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService)
  {

  }

  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.EmpNonAvailabilityRequest = new EmpNonAvailabilityRequest();
    this.GetEmpNonAvailabilityController();


  }
   

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  GetCurrentDashBoardProfileSummaryController() {

  this.StartRefreshing();
    this.CurrentJobApplyDetailsInfoByJobPostWithNurseRequest = new JobApplyDetailsInfoByJobPostWithNurseRequest();
   
    this.CurrentJobApplyDetailsInfoByJobPostWithNurseRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentJobApplyDetailsInfoByJobPostWithNurseRequest.NurseActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentJobApplyDetailsInfoByJobPostWithNurseRequest.JobPostCode = this.JobPostCode;



    
    this.hcareservice.GetJobApplyDetailsInfoByJobPostWithNurseController(this.CurrentJobApplyDetailsInfoByJobPostWithNurseRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          var result = this.ApiResData.Result;
          if (result.length > 0) {
            this.Selectedjob = result[0];

          }

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParam(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.AlertParam(' Failed Due to Internal Error.... Please Contact Admin..');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParam(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParam(error);
          this.stopRefreshing();
        }
      }


      );

  }


  



}
